import { getApi } from '../../../../../utils/api'

export function getOpenDataBuildings({ ukId, ...params }) {
  return getApi({
    endpoint: `api/open_data/uk/${ukId}/building/`,
    params,
  })
}

export function getOpenDataFlats({ buildingId, ukId, ...params }) {
  return getApi({
    endpoint: `api/open_data/uk/${ukId}/building/${buildingId}/flat/`,
    params,
  })
}
